import * as React from "react"
import PropTypes from "prop-types"
import * as styles from "./LinksWithContent-tw-styles"
import Link from "../UI/Link/Link"
import Typography from "../UI/Typography/Typography"

const LinksWithContent = props => {
  const { title, label, linksCollection, description, variant, url } = props
  const style = styles[variant] || styles.defaultStyle
  return (
    <div className={style?.bgWrapper}>
      <div className={style?.wrapper}>
        <div className={style?.leftContentWrapper}>
          {title && <h2 className={style?.title}>{title}</h2>}
          {description && (
            <Typography className={style?.description} content={description} />
          )}
          {label && (
            <Link className={style?.linkClass} label={label} url={url}></Link>
          )}
        </div>

        <div className={style?.rightContentWrapper}>
          <div className={style?.Para3}>
            {linksCollection?.items.length > 0 &&
              linksCollection?.items?.map((link, index) => {
                return (
                  <div
                    key={index}
                    className={
                      link?.isActiveLink
                        ? style?.activeLinkClass
                        : style?.linkDiv
                    }
                  >
                    {link?.__typename === "Link" && (
                      variant === "TYPO_PURPLE_BG_COL_LINK" ? 
                      <Link
                        className={`${style?.linkClass} ${link?.gaEventClass} `}
                        {...link}
                        variant="TYPO_LINK"
                      />
                    :
                      <Link
                        className={`${style?.linkClass} ${link?.gaEventClass} `}
                        {...link}
                      />
                    )}
                    {link?.__typename === "PdfRedirection" && (
                      <Link
                        className={style?.linkClass}
                        url={link?.newLink}
                        target={link?.target}
                        gaEventClass={""}
                        gaEventLabel={link?.title}
                      >
                        {link?.title}
                      </Link>
                    )}
                  </div>
                )
              })}
          </div>
        </div>
      </div>
    </div>
  )
}

LinksWithContent.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  variant: PropTypes.string,
  linksCollection: PropTypes.object,
  label: PropTypes.string,
  url: PropTypes.string,
}

export default LinksWithContent
